import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/analytics';

/**
 * Sends a GA4 page_view on every route change (SPA navigation).
 * Renders nothing.
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
